var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ 'button': true, 'is-primary': _vm.primary, 'is-rounded': _vm.rounded, 'is-small': _vm.small, 'is-large': _vm.large },attrs:{"disabled":_vm.disabled},on:{"click":($event) => !_vm.disabled && _vm.$emit('click', $event)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }